import {
	Center,
	Flex,
	Group,
	Text,
	type TextProps,
	Tooltip,
} from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export interface TitleProps extends TextProps {
	label?: string | ReactNode;
	info?: string;
	rightContent?: ReactNode;
}

export function Title({
	label,
	info,
	mb = 'xs',
	rightContent,
	...textProps
}: TitleProps) {
	return (
		<>
			<Group justify="space-between">
				<Flex dir="col" mb={mb} align={''}>
					<Text c={'grey'} fw={500} {...textProps}>
						{typeof label === 'string' ? label.toUpperCase() : label}
					</Text>
					{info && (
						<Center ml={5}>
							<Tooltip label={info} multiline w={200}>
								<IconInfoCircle
									size={'0.8rem'}
									color="grey"
									style={{ padding: 0, margin: 0 }}
								/>
							</Tooltip>
						</Center>
					)}
				</Flex>
				{rightContent && <Group align="flex-end">{rightContent}</Group>}
			</Group>
		</>
	);
}
